import React from 'react';
import { Offcanvas } from 'react-bootstrap';
import { NavLink } from 'react-router-dom';
import Collapsible from 'react-collapsible';
import { supportLinks, loggedInServiceLinks, loggedInOnlyLinks } from '../../../NavConfig';

const SidebarLoggedIn = ({ show, handleClose }) => {
   const Home = <NavLink to="/">Home</NavLink>
   const Services = <NavLink to="#">Services </NavLink>
   const Support = <NavLink to="#">Support</NavLink>

   return (
      <>
         <div>
            <Offcanvas show={show} onHide={handleClose} placement='end' className='side__bar'>
               <Offcanvas.Header closeButton>
               </Offcanvas.Header>
               <Offcanvas.Body>
                  <Collapsible trigger={Home} 
                     triggerTagName="div"
                     triggerOpenedClassName="icon_close" 
                     triggerClassName="iconAdd iconAdd-single-item" 
                     open={false}
                     triggerDisabled={true}
                  >
                  </Collapsible>
                  
                  <Collapsible trigger={Support} 
                     triggerTagName="div"
                     triggerOpenedClassName="icon_close" 
                     triggerClassName="iconAdd" 
                     open={false}
                  >
                     <ul className="submenu">
                        {supportLinks.map((link, index) => (
                           <li key={index}><NavLink to={link.to}>{link.label}</NavLink></li>
                        ))}
                     </ul>
                  </Collapsible>

                  <Collapsible trigger={Services} 
                     triggerTagName="div"
                     triggerOpenedClassName="icon_close" 
                     triggerClassName="iconAdd" 
                     open={false}
                  >
                     <ul className="sidebar_sub_menu text-white mt-3">
                        {loggedInServiceLinks.map((link, index) => (
                           <li key={index}><NavLink to={link.to}>{link.label}</NavLink></li>
                        ))}
                     </ul>
                  </Collapsible>
                  <br/>
                  
                  {loggedInOnlyLinks.map((link, index) => (
                     <Collapsible key={index} 
                        trigger={<NavLink to={link.to}>{link.label}</NavLink>}
                        triggerTagName="div"
                        triggerOpenedClassName="icon_close"
                        triggerClassName="iconAdd iconAdd-single-item"
                        open={false}
                        triggerDisabled={true}
                     >
                     </Collapsible>
                  ))}
                  
                  <Collapsible 
                     trigger={<NavLink to="/logout">Logout</NavLink>}
                     triggerTagName="div"
                     triggerOpenedClassName="icon_close"
                     triggerClassName="iconAdd iconAdd-single-item"
                     open={false}
                     triggerDisabled={true}
                  >
                  </Collapsible>
               </Offcanvas.Body>
            </Offcanvas>
         </div>
      </>
   );
};

export default SidebarLoggedIn;